import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const analyticsService = {
    // Get booking analytics with optional filters
    getBookingAnalytics: async (filters = {}) => {
        try {
            const params = new URLSearchParams();

            if (filters.startDate) {
                params.append('startDate', filters.startDate);
            }
            if (filters.endDate) {
                params.append('endDate', filters.endDate);
            }
            if (filters.eventId) {
                params.append('eventId', filters.eventId);
            }

            const response = await axios.get(`${API_BASE_URL}/analytics/bookings?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching booking analytics:', error);
            throw error;
        }
    },

    // Get list of events for filter dropdown
    getEventsList: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/analytics/events-list`);
            return response.data;
        } catch (error) {
            console.error('Error fetching events list:', error);
            throw error;
        }
    }
};

export default analyticsService;
